import React from 'react';

const OurStory = () => {
    return (
        <section className="backlight-top">
            <div className="stg-row stg-large-gap stg-m-normal-gap">
                <div className="stg-col-6 stg-tp-bottom-gap-l stg-m-bottom-gap" data-appear="fade-right" data-unload="fade-left">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/home/about01.jpg" alt="Our Story" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-vertical-space-between" data-appear="fade-left" data-unload="fade-right">
                    <div>
                        <h2>What We Do</h2>
                        <p className="infocolors-large-text">As a trusted media source, INFOCOLORS uses creativity as a powerful medium to inform, educate, and entertain. We provide a broad suite of creative and media services designed to bring your vision to life</p>
                        <p>Whether it's dynamic event coverage, cinematic videography, professional content creation, impactful ads for businesses, meticulous video editing, or stunning photography and photo editing, we blend artistic flair with technical excellence. We're also your go-to for updates on global news in sports, entertainment, and politics through our blog sites and social media, keeping you connected and informed.</p>
                    </div>
                    <a href="/contacts" className="infocolors-icon-link">
                        <div className="infocolors-icon-wrap">
                            <i className="infocolors-icon infocolors-icon-explore"></i>
                        </div>
                        <div className="infocolors-icon-link-content">
                            <h6>
                                Join the
                                <br />
                                Movement
                            </h6>
                            <span className="infocolors-label">Tell your story</span>
                        </div>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default OurStory;
